module.exports = __webpack_public_path__ + "static/teaser-dda1a065b2684888c7133f35d35ecd3c.gif";